import { useQuery } from '@tanstack/react-query'
import { configQueryOptions } from '~/domains/configuration/queries/config'

export const useGlobalMessages = () =>
  useQuery({
    ...configQueryOptions('organization.global_messages'),
    staleTime: 5 * 60_000
  })
